import PropTypes from 'prop-types';
import React from 'react';

import Container from '../../layout/Container';
import { translateLocal } from '../../../i18n';

import './AdvantagesBlock.scss';

const AdvantagesBlock = ({ data }) => {

  return (
    <div className="advantages-block">
      <Container>
        {data?.items?.map((item, index) => (
          <div key={index} className="advantage-item">
            <div className="advantage">
              <div className="title">{translateLocal(item.title)}</div>
              <div className="text text-muted">{translateLocal(item.text)}</div>
            </div>
          </div>
        ))}
      </Container>
    </div>
  );
};

AdvantagesBlock.propTypes = {
  data: PropTypes.object.isRequired,
};

export default AdvantagesBlock;
